import { bffInstance } from '../api/axiosInstance';

export const getNotificationInsights = async (data: any) => {
  const res = await bffInstance.post('/getNotificationInsights', data);
  return res.data;
};
